<template>
  <div class="text-center">
    <v-text-field
      :label="checkText ? '' : label"
      single-line
      outlined
      color="primary"
      background-color="white"
      @click="changeSheet"
      append-icon="mdi-menu-down"
      readonly
      chips
      @click:append="changeSheet"
      @click:prepend-inner="changeSheet"
    >
      <template @click="changeSheet" v-slot:prepend-inner>
        <div v-if="multiple" class="margin1">
          <span v-for="item in checkText" :key="item.key">
            <v-btn color="primary" class="margin1" v-text="item" />
          </span>
        </div>
        <div v-else>
          {{ checkText }}
        </div>
      </template>
    </v-text-field>

    <v-bottom-sheet v-model="sheet">
      <v-sheet class="text-center">
        <view-container style="padding:1vh">
          <span
            class="primary--text"
            v-text="multiple ? multipleText : selectText"
          />
          <v-divider></v-divider>
          <br />
          <v-text-field
            v-if="searchAvaible"
            class="rounded-0"
            single-line
            outlined
            color="primary"
            background-color="white"
            label="Buscar"
            persistent-hint
            prepend-inner-icon="mdi-magnify"
            append-icon=""
            @input="search"
            v-model="searchText"
          />
          <v-list subheader two-line flat>
            <v-list-item-group
              v-for="(item, index) in info"
              :key="item.key"
              v-model="activeModel"
            >
              <div v-if="visible[index]">
                <v-list-item @click="checkState(index)">
                  <v-list-item-content>
                    <v-list-item-title class="text-left" v-text="item[text]" />
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-checkbox
                      @click="checkState(index)"
                      v-model="check[index]"
                      :input-value="check[index]"
                      color="secondary"
                    ></v-checkbox>
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
              </div>
            </v-list-item-group>
          </v-list>
        </view-container>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>

<script>
import { AutoContainer, ViewContainer } from "@/components";

const props = {
  info: {
    default: [],
    type: Array,
  },
  text: {
    default: "nombre",
    type: String,
  },
  label: {
    default: "Seleccione",
    type: String,
  },
  multiple: {
    default: false,
    type: Boolean,
  },
  selectText: {
    default: "Selecciona uno",
    type: String,
  },
  multipleText: {
    default: "Selecciona uno o varios",
    type: String,
  },
  searchAvaible: {
    default: false,
    type: Boolean,
  },
  clean: {
    default: false,
    type: Boolean,
  },
  formReserv: undefined,
  checkFirst: {
    default: false,
    type: Boolean,
  },
};

export default {
  components: {
    AutoContainer,
    ViewContainer,
  },
  data: () => ({
    sheet: false,
    check: [],
    checkText: "",
    activeModel: undefined,
    searchText: "",
    visible: [],
  }),
  mounted() {
    for (let i = 0; i < this.info.length; i++) {
      this.check[i] = false;
      this.visible[i] = true;
    }
    if (this.multiple) {
      this.checkText = [];
    }
  },
  computed: {
    cleanInfo() {
      return this.clean;
    },
  },
  watch: {
    cleanInfo() {
      for (let i = 0; i < this.check.length; i++) {
        this.check[i] = false;
        this.checkText = "";
        // this.$emit("click", this.info[i], this.formReserv);
      }
    },
    checkFirst() {
      this.checkStateFirst(0);
    },
  },
  methods: {
    execute() {
      if (this.onClick) {
        this.onClick();
      }
    },
    checkState(position) {
      if (!this.multiple) {
        for (let i = 0; i < this.check.length; i++) {
          if (position == i) {
            this.check[i] = true;
            this.checkText = this.info[i][this.text];
            this.$emit("click", this.info[i], this.formReserv);
          } else {
            this.check[i] = false;
          }
        }
        setTimeout(() => {
          this.sheet = !this.sheet;
        }, 150);
      } else {
        for (let i = 0; i < this.check.length; i++) {
          if (position == i) {
            this.check[i] = !this.check[i];
            if (this.check[i]) {
              this.checkText.push(this.info[i][this.text]);
            } else {
              for (let j = 0; j < this.checkText.length; j++) {
                if (this.checkText[j] === this.info[i][this.text]) {
                  this.checkText.splice(j, 1);
                }
              }
            }
            this.$emit("click", this.checkText, this.formReserv);
          }
        }
      }
    },
    checkStateFirst(position) {
      if (!this.multiple) {
        for (let i = 0; i < this.check.length; i++) {
          if (position == i) {
            this.check[i] = true;
            this.checkText = this.info[i][this.text];
            this.$emit("change", this.info[i], this.formReserv);
          } else {
            this.check[i] = false;
          }
        }
        setTimeout(() => {
          this.sheet = false;
        }, 150);
      } else {
        for (let i = 0; i < this.check.length; i++) {
          if (position == i) {
            this.check[i] = !this.check[i];
            if (this.check[i]) {
              this.checkText.push(this.info[i][this.text]);
            } else {
              for (let j = 0; j < this.checkText.length; j++) {
                if (this.checkText[j] === this.info[i][this.text]) {
                  this.checkText.splice(j, 1);
                }
              }
            }
            this.$emit("change", this.checkText, this.formReserv);
          }
        }
      }
    },
    changeSheet() {
      this.sheet = !this.sheet;
    },
    Change(prop) {
      this.$emit("input", prop);
    },
    search() {
      for (let i = 0; i < this.info.length; i++) {
        const regex = new RegExp(this.searchText.toLowerCase(), "gi");
        if (this.info[i][this.text].toLowerCase().match(regex)) {
          this.visible[i] = true;
        } else {
          this.visible[i] = false;
        }
      }
    },
  },
  props: props,
};
</script>

<style scoped>
.margin1 {
  margin: 2px;
}
</style>
